var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReverseYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H18C19.1046 0 20 0.895431 20 2V18C20 19.1046 19.1046 20 18 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "#FFB803"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.81631 5.58058C3.32816 5.09243 3.32816 4.30097 3.81631 3.81282C7.2334 0.395728 12.7736 0.395728 16.1907 3.81282C19.6078 7.2299 19.6078 12.7701 16.1907 16.1872C12.7736 19.6043 7.2334 19.6043 3.81631 16.1872C3.32816 15.699 3.32816 14.9076 3.81631 14.4194C4.30447 13.9313 5.09592 13.9313 5.58408 14.4194C8.02486 16.8602 11.9821 16.8602 14.4229 14.4194C16.8637 11.9786 16.8637 8.02136 14.4229 5.58058C11.9821 3.13981 8.02486 3.13981 5.58408 5.58058C5.09592 6.06874 4.30447 6.06874 3.81631 5.58058Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6138 6.76932C2.81124 7.19984 3.24602 7.49892 3.7506 7.499C3.75269 7.499 3.75477 7.499 3.75686 7.49899L7.5 7.49959C8.19024 7.4997 8.74971 6.94023 8.7496 6.24998C8.74949 5.55974 8.18984 5.00009 7.4996 4.99998L5 4.99959L4.9996 2.5C4.99949 1.80975 4.43985 1.25011 3.7496 1.25C3.05936 1.24989 2.49989 1.80935 2.5 2.4996L2.5006 6.24529C2.5006 6.24652 2.50059 6.24776 2.50059 6.24899C2.50061 6.33527 2.50937 6.41952 2.52603 6.50089",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverseYellow);
export default __webpack_public_path__ + "static/media/reverse-yellow.5f3ae90160764a48648d1a761cfe758c.svg";
export { ForwardRef as ReactComponent };